import { BSidebarItem } from '@barbanet/ui-kit/components'

const sidebarItems = [
	{
		id: 'billOfLading',
		label: 'shared.billOfLading',
		icon: 'truck',
		children: [
			{
				id: 'billOfLadingWarehouse',
				label: 'shared.billOfLadingWarehouse',
				to: { name: 'BillOfLadingWarehouseReport' }
			},
			{
				id: 'readyToProcess',
				label: 'shared.billsReadyToProcessing',
				to: { name: 'BillOfLadingReadyToProcessReport' }
			},
			{
				id: 'processing',
				label: 'shared.billsProcessing',
				to: { name: 'BillOfLadingProcessingReport' }
			},
			{
				id: 'waitingToPay',
				label: 'shared.waitingToPay',
				to: { name: 'BillOfLadingWaitingToPayReport' }
			},
			{
				id: 'paymentQueue',
				label: 'shared.paymentQueue',
				to: { name: 'BillOfLadingPaymentQueueReport' }
			},
			{
				id: 'paymentSuccess',
				label: 'shared.paymentSuccess',
				to: { name: 'BillOfLadingPaymentSuccessReport' }
			},
			{
				id: 'paymentFailed',
				label: 'shared.paymentFailed',
				to: { name: 'BillOfLadingPaymentFailedReport' }
			}
		]
	},
	{
		id: 'setting',
		label: 'shared.setting',
		icon: 'settings-01',
		children: [
			{
				id: 'CompanyProfile',
				label: 'shared.companyProfile',
				to: { name: 'CompanyProfile' }
			},
			{
				id: 'SettingBaseInfo',
				label: 'shared.baseInfo',
				to: { name: 'SettingBaseInfo' }
			}
		]
	}
] as BSidebarItem[]

export default sidebarItems
